export const bezierCurve = [0.04, 0.02, 0.22, 1];
export const transformScale = [2, 1];

export const data = {
  titleLines: ['The current', 'account for', 'your travel money'],
  subTitle:
    'Great escapes, meet your match. <b>Spend and withdraw cash with your Starling current account anywhere, with no fees from us.</b>',
  animationVariants: {
    title: {
      visible: {
        x: 0,
        y: 0,
        transition: {
          ease: bezierCurve,
          delayChildren: 0.25,
          staggerChildren: 0.02
        }
      }
    },
    titleCharacter: {
      visible: {
        y: 0,
        transition: {
          ease: bezierCurve,
          duration: 0.25
        }
      },
      hidden: { y: '112%' }
    },
    subTitle: {
      visible: {
        x: 0,
        y: 0,
        transition: {
          ease: bezierCurve,
          staggerChildren: 0.45
        }
      }
    },
    subTitleChild: {
      visible: {
        y: 0,
        transition: {
          ease: bezierCurve,
          duration: 0.4
        }
      },
      hidden: {
        y: '150%'
      }
    }
  }
};
